import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 pt-16">
      <div className="text-center px-4">
        <h1 className="text-6xl md:text-8xl font-heading font-bold text-primary-500">404</h1>
        <p className="mt-4 text-lg md:text-xl text-foreground-700 font-heading">Page Not Found</p>
        <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto">
          The page you are looking for does not exist. Return to the homepage to explore mulebuy spreadsheet resources.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-home-4-line"></i> Back to Homepage
        </Link>
      </div>
    </div>
  );
}